import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Instancia para superadmin / admin de empresa (sesión con token 'app_token')
export const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('app_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Instancia para el kiosko de la tablet (token de activación 'kiosk_token')
export const kioskApi = axios.create({ baseURL: API });
kioskApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('kiosk_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Instancia para la App del Empleado (móvil personal, token 'empapp_token')
export const empApi = axios.create({ baseURL: API });
empApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('empapp_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const getToken = () => localStorage.getItem('app_token');
